export type Disaster = {
  year: number;
  month: string;
  disasters: number;
};
const disasters: Disaster[] = [
  { year: 2022, month: "January", disasters: 5 },
  { year: 2022, month: "February", disasters: 3 },
  { year: 2022, month: "March", disasters: 8 },
  { year: 2022, month: "April", disasters: 6 },
  { year: 2022, month: "May", disasters: 7 },
  { year: 2022, month: "June", disasters: 4 },
  { year: 2022, month: "July", disasters: 9 },
  { year: 2022, month: "August", disasters: 5 },
  { year: 2022, month: "September", disasters: 3 },
  { year: 2022, month: "October", disasters: 6 },
  { year: 2022, month: "November", disasters: 8 },
  { year: 2022, month: "December", disasters: 5 },
  { year: 2021, month: "January", disasters: 5 },
  { year: 2021, month: "February", disasters: 13 },
  { year: 2021, month: "March", disasters: 8 },
  { year: 2021, month: "April", disasters: 16 },
  { year: 2021, month: "May", disasters: 17 },
  { year: 2021, month: "June", disasters: 14 },
  { year: 2021, month: "July", disasters: 29 },
  { year: 2021, month: "August", disasters: 25 },
  { year: 2021, month: "September", disasters: 3 },
  { year: 2021, month: "October", disasters: 16 },
  { year: 2021, month: "November", disasters: 12 },
  { year: 2021, month: "December", disasters: 5 },
  { year: 2020, month: "January", disasters: 5 },
  { year: 2020, month: "February", disasters: 3 },
  { year: 2020, month: "March", disasters: 8 },
  { year: 2020, month: "April", disasters: 6 },
  { year: 2020, month: "May", disasters: 7 },
  { year: 2020, month: "June", disasters: 4 },
  { year: 2020, month: "July", disasters: 9 },
  { year: 2020, month: "August", disasters: 5 },
  { year: 2020, month: "September", disasters: 3 },
  { year: 2020, month: "October", disasters: 6 },
  { year: 2020, month: "November", disasters: 8 },
  { year: 2020, month: "December", disasters: 5 },
  { year: 2019, month: "January", disasters: 5 },
  { year: 2019, month: "February", disasters: 3 },
  { year: 2019, month: "March", disasters: 8 },
  { year: 2019, month: "April", disasters: 6 },
  { year: 2019, month: "May", disasters: 7 },
  { year: 2019, month: "June", disasters: 4 },
  { year: 2019, month: "July", disasters: 9 },
  { year: 2019, month: "August", disasters: 5 },
  { year: 2019, month: "September", disasters: 3 },
  { year: 2019, month: "October", disasters: 6 },
  { year: 2019, month: "November", disasters: 4 },
];

export default disasters;
